import { useMutation, useQueryClient } from "@tanstack/react-query";
import client from "api/graphql/getClient";
import { graphql } from "gql/gql";
import { useActiveAccount } from "utils/useActiveAccount";
import { UpdateAPIKeyParams } from "gql/graphql";

const updateAPIKeyDocument = graphql(/* GraphQL */ `
	mutation updateAPIKey($params: UpdateAPIKeyParams!) {
		updateAPIKey(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

interface Args {
	params: UpdateAPIKeyParams;
	userId?: string;
}

const updateAPIKey = ({ userId, params }: Args) =>
	client(userId)
		.request(updateAPIKeyDocument, { params })
		.then((res) => res.updateAPIKey);

const useUpdateAPIKey = () => {
	const { _id, userId } = useActiveAccount();
	const queryClient = useQueryClient();

	return useMutation(
		(params: UpdateAPIKeyParams) => updateAPIKey({ params, userId }),
		{
			onSettled: () => {
				queryClient.invalidateQueries(["user", userId, "account", _id], {
					exact: true,
				});
			},
		}
	);
};

export default useUpdateAPIKey;
